import request from '@/util/request';

export const getList = (current, size, params) => {
  return request({
    url: '/api/energe/feeenergyuse/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const submitUploadBill = (formData) => {
  return request({
    url: '/api/energe/feeenergyuse/uploadBill',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const queryShortCode = (queryString) => {
  return request({
    url: '/api/energe/feeenergyuse/queryShortCodes',
    method: 'get',
    params: {
      queryString,
    },
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/energe/feeenergyuse/detail',
    method: 'get',
    params: {
      id,
    },
  });
};

export const createEnergyBill = (ids) => {
  return request({
    url: '/api/energe/feeenergyuse/createBill',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: '/api/energe/feeenergyuse/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: '/api/energe/feeenergyuse/submit',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/energe/feeenergyuse/update',
    method: 'post',
    data: row,
  });
};
